// Main II functions
(function(II) {
	//Get default title
	var title = document.title;
	//check for unseen items every ten minutes
	setInterval(function () {
		
		var xhr = new XMLHttpRequest();
		
		xhr.onreadystatechange = function () {
			if (xhr.readyState === 4 && xhr.status === 200 && xhr.responseText != 0) {
				var itemCount = document.getElementById('header_item_count');
				itemCount.style.display = 'inline';
				itemCount.innerHTML = xhr.responseText;
				document.title = "("+xhr.responseText+")  " + title;
			}
		};
		xhr.open('GET', '/misseditemcount');
		xhr.send();


	}, 1000*60*10);

	///// Public methods \\\\\
	// IN: id of keyphrase url
	II.clickTrack = function(id) {
		
		var xhr = new XMLHttpRequest();
		
		xhr.open('POST','/forward');
		xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
		xhr.send('id='+id);
	};
	
})(window.II = window.II || {});
